import Vue from "vue";
import Vuex from "vuex";
import HelperDeviceDetect from "@/helpers/HelperDeviceDetect";
import axios from "axios";

axios.defaults.headers.common["app-type"] = "web";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: null,
    receipt: null,
    conflict: false,
    authAction: null
  },
  mutations: {
    SET_AUTH_ACTION(state, authAction) {
      state.authAction = authAction;
    },
    SET_USER_DATA(state, userData) {
      state.user = userData;

      let expires = "";
      let days = 1;
      let date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toGMTString();

      localStorage.setItem("token", userData.token.bearer);
      localStorage.setItem("userInfo", JSON.stringify(userData));
      document.cookie = `token=${userData.token.bearer}${expires}; domain=${process.env.VUE_APP_COOKIE_DOMAIN}; path=/;`;
      document.cookie = `action=${userData.action}${expires}; domain=${process.env.VUE_APP_COOKIE_DOMAIN}; path=/;`;
      document.cookie = `method=${userData.method}${expires}; domain=${process.env.VUE_APP_COOKIE_DOMAIN}; path=/;`;
      document.cookie = `userId=${userData.user.userId}${expires}; domain=${process.env.VUE_APP_COOKIE_DOMAIN}; path=/;`;
    },
    UPDATE_USER_PHONE_DATA(state, phone) {
      state.user.user.phone = phone;
    }
  },
  actions: {
    login({ commit }, credentials) {
      let data = {
        credentials,
        device: HelperDeviceDetect.deviceInfo()
      };

      return axios
        .post(`${process.env.VUE_APP_HOST_WS}/auth/login/by/email`, data)
        .then(({ data }) => {
          commit("SET_USER_DATA", data.result);
        });
    },
    registerWithFacebook({ commit }, token) {
      let data = {
        credentials: {
          token
        },
        device: HelperDeviceDetect.deviceInfo()
      };
      return axios
        .post(
          `${process.env.VUE_APP_HOST_WS}/auth/connect/with/facebook`,
          data,
          {
            "app-type": "web"
          }
        )
        .then(({ data }) => {
          commit("SET_USER_DATA", data.result);
          commit("SET_AUTH_ACTION", data.result.action);
        });
    },
    registerWithGoogle({ commit }, token) {
      let data = {
        credentials: {
          token
        },
        device: HelperDeviceDetect.deviceInfo()
      };
      return axios
        .post(`${process.env.VUE_APP_HOST_WS}/auth/connect/with/google`, data)
        .then(({ data }) => {
          commit("SET_USER_DATA", data.result);
          commit("SET_AUTH_ACTION", data.result.action);
        });
    },
    authorizeWithApple({ commit }, { code }) {
      let data = {
        credentials: {
          authorizationCode: code
        },
        device: HelperDeviceDetect.deviceInfo()
      };
      return axios
        .post(`${process.env.VUE_APP_HOST_WS}/auth/connect/with/apple`, data)
        .then(({ data }) => {
          commit("SET_USER_DATA", data.result);
          commit("SET_AUTH_ACTION", data.result.action);
        });
    },
    authorizeWithDiscord({ commit }, token) {
      let data = {
        credentials: {
          token: token
        },
        device: HelperDeviceDetect.deviceInfo()
      };
      return axios
        .post(`${process.env.VUE_APP_HOST_WS}/auth/connect/with/discord`, data)
        .then(({ data }) => {
          commit("SET_USER_DATA", data.result);
          commit("SET_AUTH_ACTION", data.result.action);
        });
    },
    async register({ commit }, user) {
      let data = {
        credentials: {
          email: user.email,
          password: user.password
        },
        profile: {
          firstName: "",
          brandName: "",
          gender: ["Male", "Female"].includes(user.gender) ? user.gender : null,
          birthYear: user.birthYear
        },
        device: HelperDeviceDetect.deviceInfo()
      };
      return await new Promise((resolve, reject) => {
        axios
          .post(`${process.env.VUE_APP_HOST_WS}/auth/register/by/email`, data)
          .then(({ data }) => {
            commit("SET_USER_DATA", data.result);
            commit("SET_AUTH_ACTION", data.result.action);
            resolve(data.result);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    updateProfile({ state }, data) {
      const headers = {
        authorization: `bearer ${state.user.token.bearer}`
      };

      return axios
        .put(`${process.env.VUE_APP_HOST_WS}/api/users/profile`, data, {
          headers: headers
        })
        .then(res => {
          return !!(res.status === 200);
        });
    },

    updateUserPhone({ state, commit }, user) {
      const headers = {
        authorization: `bearer ${state.user.token.bearer}`
      };

      return axios
        .put(`${process.env.VUE_APP_HOST_WS}/api/users/profile`, user, {
          headers: headers
        })
        .then(() => {
          commit("UPDATE_USER_PHONE_DATA", user.phone);
        });
    },

    forgotPassword(store, credentials) {
      let data = {
        credentials,
        device: HelperDeviceDetect.deviceInfo()
      };
      return axios.post(
        `${process.env.VUE_APP_HOST_WS}/auth/request/magic-link`,
        data
      );
    },
    resetPassword(store, credentials) {
      let data = {
        credentials,
        device: HelperDeviceDetect.deviceInfo()
      };
      return axios
        .post(`${process.env.VUE_APP_HOST_WS}/auth/reset-password`, data)
        .then(() => {
          console.log("success");
        });
    }
  },
  getters: {
    getUser(state) {
      return state.user;
    },
    loggedIn(state) {
      return !!state.user;
    },
    hasPhoneNumber(state) {
      return !!state.user.user.phone;
    },
    getToken() {
      return localStorage.getItem("token");
    },
    getAuthAction(state) {
      return state.authAction;
    }
  }
});
